const GROUP_PLACEHOLDER = 'placeholder'
const GROUP_LABEL = 'label'
const GROUP_LAYOUT = 'layout'

export const LANGUAGE_PLACEHOLDERDATE = GROUP_PLACEHOLDER + '.date'
export const LANGUAGE_PLACEHOLDERSEARCH = GROUP_PLACEHOLDER + '.search'

export const LANGUAGE_LABELNORESULTS = GROUP_LABEL + '.noresults'
export const LANGUAGE_LABELRESULTCOUNT = GROUP_LABEL + '.resultcount'
export const LANGUAGE_LABELRESET = GROUP_LABEL + '.reset'
export const LANGUAGE_LABELRECYCLEBIN = GROUP_LABEL + '.recyclebin'

export const LANGUAGE_LAYOUTLIST = GROUP_LAYOUT + '.list'
export const LANGUAGE_LAYOUTGRID = GROUP_LAYOUT + '.grid'
export const LANGUAGE_LAYOUTCOMPACT = GROUP_LAYOUT + '.compact'
export const LANGUAGE_LAYOUTCARD = GROUP_LAYOUT + '.card'